import type { BoardField, FieldType, FieldValue } from "@kandoo/shared";

export const FIELD_TYPE_LABELS: Record<FieldType, string> = {
  text: "Text",
  number: "Number",
  date: "Date",
  checkbox: "Checkbox",
  select: "Dropdown",
  url: "Link",
};

/** A value as short display text (card-face pills, table cells). */
export function formatFieldValue(field: BoardField, value: FieldValue | undefined): string {
  if (value === undefined || value === null) return "";
  switch (field.type) {
    case "select":
      return field.options.find((o) => o.id === value)?.name ?? "";
    case "checkbox":
      return value ? "✓" : "";
    case "date": {
      // a calendar day, so format it without a timezone shift
      const [y, m, d] = String(value).split("-").map(Number);
      return new Date(y, m - 1, d).toLocaleDateString(undefined, {
        month: "short",
        day: "numeric",
      });
    }
    case "url":
      try {
        return new URL(String(value)).hostname.replace(/^www\./, "");
      } catch {
        return String(value);
      }
    default:
      return String(value);
  }
}
